import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isLoading: false,
  pendingLeaveList: [],
  pendingOffsiteWorkList: [],
  pendingRedeemTimeList: [],
  pendingEndorseTimeList: [],
  pendingOvertimeList: [],
  pendingCollectTimeList: [],
  pendingWarningLetterList: [],
  pendingDocumentList: [],
  pendingChangeShiftList: [],
  pendingExpense: [],
  pendingMovement: [],
  actionHistory: [],

  leaveRequestId: null,
  offsiteWorkRequestId: null,
  redeemTimeRequestId: null,
  warningLetterRequestId: null,
  historyLeaveList: [],
  historyOffsiteWorkList: [],
  historyRedeemTimeList: [],
  historyEndorseTimeList: [],
  historyOvertimeList: [],
  historyCollectTimeList: [],
  historyWarningLetterList: [],
  historyDocumentList: [],
  historyChangeShiftList: [],
  historyExpense: [],
  historyMovement: [],


};

const pendingApprovalSlice = createSlice({
  name: "requestApproval",
  initialState,
  reducers: {
    setIsLoading(state, action) {
      state.isLoading = action.payload;
    },
    setActionHistory(state, action) {
      state.actionHistory = action.payload;
    },
    setPendingLeaveList(state, action) {
      state.pendingLeaveList = action.payload;
    },
    setPendingOffsiteWorkList(state, action) {
      state.pendingOffsiteWorkList = action.payload;
    },
    setPendingRedeemTimeList(state, action) {
      state.pendingRedeemTimeList = action.payload;
    },
    setPendingEndorseTimeList(state, action) {
      state.pendingEndorseTimeList = action.payload;
    },
    setPendingOvertimeList(state, action) {
      state.pendingOvertimeList = action.payload;
    },
    setPendingCollectTimeList(state, action) {
      state.pendingCollectTimeList = action.payload;
    },
    setPendingWarningLetterList(state, action) {
      state.pendingWarningLetterList = action.payload;
    },

    setPendingDocumentList(state, action) {
      state.pendingDocumentList = action.payload;
    },
    setPendingChangeShiftList(state, action) {
      state.pendingChangeShiftList = action.payload;
    },
    setWarningLetterRequestId(state, action) {
      state.warningLetterRequestId = action.payload
    },
    setPendindExpenseList(state, action) {
      state.pendingExpense = action.payload
    },
    setPendingMovement(state, action) {
      state.pendingMovement = action.payload
    },
    setHistoryLeaveList(state, action) {
      state.historyLeaveList = action.payload
    },
    setHistoryOffsiteWorkList(state, action) {
      state.historyOffsiteWorkList = action.payload
    },
    setHistoryRedeemTimeList(state, action) {
      state.historyRedeemTimeList = action.payload
    },
    setHistoryEndorseTimeList(state, action) {
      state.historyEndorseTimeList = action.payload
    },
    setHistoryOvertimeList(state, action) {
      state.historyOvertimeList = action.payload
    },
    setHistoryCollectTimeList(state, action) {
      state.historyCollectTimeList = action.payload
    },
    setHistoryWarningLetterList(state, action) {
      state.historyWarningLetterList = action.payload
    },
    setHistoryDocumentList(state, action) {
      state.historyDocumentList = action.payload
    },
    setHistoryChangeShiftList(state, action) {
      state.historyChangeShiftList = action.payload
    },
    setHistoryExpense(state, action) {
      state.historyExpense = action.payload
    },
    setHistoryMovement(state, action) {
      state.historyMovement = action.payload
    },

    // You can add more reducers here if needed
  },
});

export const {
  setIsLoading,
  setPendingLeaveList,
  setPendingOffsiteWorkList,
  setPendingRedeemTimeList,
  setPendingEndorseTimeList,
  setPendingOvertimeList,
  setPendingCollectTimeList,
  setActionHistory,
  setPendingWarningLetterList,
  setPendingDocumentList,
  setPendingChangeShiftList,
  setPendindExpenseList,
  setPendingMovement,
  setHistoryLeaveList,
  setHistoryOffsiteWorkList,
  setHistoryRedeemTimeList,
  setHistoryEndorseTimeList,
  setHistoryOvertimeList,
  setHistoryCollectTimeList,
  setHistoryWarningLetterList,
  setHistoryDocumentList,
  setHistoryChangeShiftList,
  setHistoryExpense,
  setHistoryMovement,
  // Add other exported actions here if needed
} = pendingApprovalSlice.actions;

export default pendingApprovalSlice.reducer;
